





























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ServiceAgent from '../../../services/serviceAgent';
import UserDTO from '../../../objects/userDTO';

const serviceAgent = new ServiceAgent();

@Component
export default class SignUp extends Vue {
    @Prop() successSignInCallback!: Function;

    userDTO = new UserDTO();

    dialog = false;

    menu = false;

    formValid = false;

    validationRules = {
        required: (v: string) => !!v || 'Field is required',
        passwordConfirm: (v: string) => v === this.userDTO.Password || 'Passwords does not match',
        emailValidate: (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        passwordLength: (v: string) => v.length >= 8 || 'Password length shold be more then 8 characters',
    }

    async signUpSubmit() {
        (this.$refs.form as any).validate();
        if (!this.formValid) return;

        await serviceAgent.SignUp(this.userDTO);

        this.successSignInCallback();
        this.dialog = false;
    }
}
